import { IntlShape } from 'react-intl';
import { WirPauseStates } from 'types/wellGuardian';

export const getPausedStatusTitle = (intl: IntlShape, pausedState: WirPauseStates | undefined) => {
  return pausedState === WirPauseStates.ARCHIVED
    ? intl.formatMessage({
        id: 'wellGuardian.wir.wirCreation.archived',
      })
    : intl.formatMessage({
        id: 'wellGuardian.wir.wirCreation.paused',
      });
};
